import Box, { BoxProps } from '@mui/material/Box';

export function DisplayMarkup(props: {
  markup: string | null;
  sx?: BoxProps['sx'];
}) {
  const createMarkup = (__html: string) => {
    return { __html };
  };

  if (props.markup) {
    return (
      <Box sx={props.sx} dangerouslySetInnerHTML={createMarkup(props.markup)} />
    );
  } else {
    return null;
  }
}
